module.exports = __webpack_public_path__ + "ecran-crédits.gif?912a3d08c87606490f32970ee19e177c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ecran-crédits.gif
// module id = 170
// module chunks = 0